import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type {
    GetAdminOrganizationStripeBillingByMonthResponse,
    UseGetAdminOrganizationStripeBillingByMonthParams,
    UseGetAdminOrganizationStripeBillingByMonthResult,
} from './types';

const useGetAdminOrganizationStripeBillingByMonth = ({
    organizationId,
    month,
}: UseGetAdminOrganizationStripeBillingByMonthParams): UseGetAdminOrganizationStripeBillingByMonthResult => {
    const searchParams = new URLSearchParams({ month });
    const pathname = `/admin/organizations/${encodeURIComponent(organizationId)}/stripe-billing?${searchParams.toString()}`;

    const { data, isLoading, error, refetch } =
        useHttpQuery<GetAdminOrganizationStripeBillingByMonthResponse>({
            pathname,
            method: 'GET',
            key: ['admin-organization-stripe-billing-by-month', organizationId, month],
            queryOptions: {
                enabled: organizationId.length > 0 && month.length > 0,
            },
        });

    return {
        billing: data?.data ?? null,
        isLoadingBilling: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useGetAdminOrganizationStripeBillingByMonth;
